import React, { useEffect, useState } from "react";
import api from "@/lib/api";
import { PageHeader, InfoNote } from "@/components/Common";
import { Card } from "@/components/ui/card";
import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from "@/components/ui/table";
import { Lock } from "lucide-react";

export default function AuditTrail() {
  const [events, setEvents] = useState([]);
  useEffect(() => { api.audit().then(setEvents).catch(() => {}); }, []);

  return (
    <div>
      <PageHeader testid="audit-header" title="Audit Trail"
        subtitle="Append-only, hash-chained event history across all orders. Events cannot be edited or deleted through the UI." />
      <InfoNote className="mb-4"><Lock className="mr-1 inline h-3 w-3" /> Tamper-evident: each event stores the previous event hash and its own hash. Deletion is not exposed to any role.</InfoNote>
      <Card className="overflow-hidden">
        <Table>
          <TableHeader>
            <TableRow>
              <TableHead>Time</TableHead><TableHead>Order</TableHead><TableHead>Event</TableHead>
              <TableHead>Actor</TableHead><TableHead>State →</TableHead><TableHead>Policy</TableHead><TableHead>Hash</TableHead>
            </TableRow>
          </TableHeader>
          <TableBody>
            {events.length === 0 && <TableRow><TableCell colSpan={7} className="py-8 text-center text-sm text-slate-500">No audit events yet.</TableCell></TableRow>}
            {events.map((e) => (
              <TableRow key={e.id} data-testid={`audit-row-${e.seq}`}>
                <TableCell className="whitespace-nowrap font-mono text-[10px] text-slate-500">{new Date(e.timestamp).toLocaleString()}</TableCell>
                <TableCell className="font-mono text-[10px]">{e.order_number || "—"}</TableCell>
                <TableCell className="text-xs font-medium text-slate-800">{e.event_type.replace(/_/g, " ")}</TableCell>
                <TableCell className="text-xs">{e.actor}<div className="text-[10px] text-slate-400">{e.role}</div></TableCell>
                <TableCell className="text-xs">{e.new_state || "—"}</TableCell>
                <TableCell className="text-xs">{e.policy_version || "—"}</TableCell>
                <TableCell className="font-mono text-[9px] text-slate-400">{e.event_hash?.slice(0, 12)}…</TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </Card>
    </div>
  );
}
